export const isSSTUser = async () => {
  return fetch('/signup/i/sst_user/')
    .then((response) => {
      if (!response.ok) {
        return {
          result: false,
        };
      }
      return response.json();
    })
    .then((res) => res.result)
    .catch((e) => {
      console.error(e);
      return false;
    });
};
